import { TFn } from "@/app/translations/TFn";
import { TKey } from "@/app/translations/TKey";

const OBJECTIVE_SUGGESTION_KEYS: TKey[] = [
  TKey.MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_1,
  TKey.MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_2,
  TKey.MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_3,
  TKey.MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_4,
  TKey.MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_5,
  TKey.MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_6,
  TKey.MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_7,
  TKey.MESSAGES_CONTENT_OBJECTIVE_SUGGESTION_8,
];

export function objectiveSuggestions(T: TFn, taken: string[]): string[] {
  const used = new Set(taken.map((label) => label.trim().toLowerCase()));
  return OBJECTIVE_SUGGESTION_KEYS.map((key) => String(T(key))).filter(
    (label) => !used.has(label.toLowerCase()),
  );
}
